import { PrismicNextLink } from "@prismicio/next";
import styled from "styled-components";

export const Container = styled.div`
  max-width: 1280px;
  width: 100%;
  margin: auto;
  padding: 120px 32px 90px;
  text-align: center;
  color: #001159;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const Title = styled.div`
  max-width: 640px;
  margin: auto;
  font-size: 60px;

  @media only screen and (max-width: 768px) {
    font-size: 42px;
  }
`;

export const Description = styled.div`
  max-width: 550px;
  margin: auto;
  strong {
    color: #27bd83;
  }
`;

export const Button = styled(PrismicNextLink)`
  all: unset;
  font-size: 22px;
  line-height: 30px;
  padding: 15px 30px;
  border: 2px solid white;
  border-radius: 1000px;
  cursor: pointer;
  width: min-content;
  margin-top: 42px;
  white-space: nowrap;

  color: #001159;
  border-color: #001159;
`;
